module.exports = __webpack_public_path__ + "img/loader.27e2ef14.svg";